// Dependencies
import React, { memo } from "react";

// Components
import ScannerQrCode from "./components/ScannerQrCode";

const QrCode = () => {
    return <ScannerQrCode />;
};

export default memo(QrCode);
